import { render, staticRenderFns } from "./file_view.vue?vue&type=template&id=f9ad1c26&scoped=true&"
import script from "./file_view.vue?vue&type=script&lang=ts&"
export * from "./file_view.vue?vue&type=script&lang=ts&"
import style0 from "./file_view.vue?vue&type=style&index=0&id=f9ad1c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ad1c26",
  null
  
)

export default component.exports